import React from 'react';

export default () => <i className="f7-icons color-custom">placemark_fill</i>;
